import { InfoSection } from '@components'

import { Link, Text } from '@billy/design-system'
import { ReactElement } from 'react'
import { Trans, useTranslation } from 'react-i18next'

import { NL_AUTHORITY_URL } from '../../../../consts/taxAuthoritiesUrls'

export const ModalBodyNL = (): ReactElement => {
  const { t } = useTranslation()

  const infoText = (
    <Trans i18nKey="vat_declarations.settlement_modal.modal_body.body_info_nl" value="test">
      Please note that you must submit the figures to
      <Link href={NL_AUTHORITY_URL} target="_blank" rel="noreferrer">
        Belastingdienst
      </Link>
      yourself.
    </Trans>
  )

  return (
    <>
      <Text>{t('vat_declarations.settlement_modal.modal_body.body_text_nl')}</Text>
      <InfoSection infoText={infoText} />
    </>
  )
}
